import { render, staticRenderFns } from "./CytPrefixCpt.vue?vue&type=template&id=53decc55&scoped=true&"
import script from "./CytPrefixCpt.vue?vue&type=script&lang=js&"
export * from "./CytPrefixCpt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53decc55",
  null
  
)

export default component.exports